module.exports = __webpack_public_path__ + "img/tarj4-2.12217f95.svg";